import React from 'react';

export const truncateStr = (str, chars) => (
	<span title={str}>
		{((str && str.charAt(+chars)) ? `${str.substring(0, +chars)}...` : str)}
	</span>
);

export const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);
